import script from "./PolicyPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./PolicyPreviewModal.vue?vue&type=style&index=0&id=ea60ae48&lang=scss"

const __exports__ = script;

export default __exports__